import React from "react";
import PropTypes from 'prop-types';
import { TextArea, useFormValidation } from "../../index";

export const TextAreaWithValidation = ({
    customValidation,
    errorMsg,
    hintMsg,
    minLength,
    name,
    onBlur = () => { },
    onChange = () => { },
    pattern,
    required = false,
    ...props
}) => {

    const validationRules = {
        [name]: {
            required: {
                value: required,
                message: errorMsg
            },
            pattern: {
                value: pattern,
                message: errorMsg
            },
            custom: {
                isValid: customValidation ? customValidation : (value) => { return minLength ? value.length >= minLength : true },
                message: errorMsg
            }
        }
    };

    const { handleInput, formErrors } = useFormValidation({ validations: validationRules });

    const handleChange = (event) => {
        const value = event.target.value;
        handleInput(event);

        if (onChange) {
            onChange(event, value, formErrors[name]?.value);
        }
    }

    const handleBlur = (event) => {
        const value = event.target.value;
        handleInput(event);

        if (onBlur) {
            onBlur(event, value, formErrors[name]?.value);
        }
    }

    return (
        <TextArea
            {...props}
            error={formErrors[name]?.value}
            hintMsg={formErrors[name]?.message ? formErrors[name]?.message : hintMsg}
            minLength={minLength}
            name={name}
            onBlur={handleBlur}
            onChange={handleChange}
            required={required}
        />
    )
}

TextAreaWithValidation.propTypes = {
    customValidation: PropTypes.func,
    errorMsg: PropTypes.string,
    hintMsg: PropTypes.string,
    minLength: PropTypes.number,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    pattern: PropTypes.string,
    required: PropTypes.bool,
}